<template>
  <div class="not-found-container">
    <FriedH1>{{ t('dsr_aw_we_could_not_load_your_dsr') }}</FriedH1>
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NotFound',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.not-found-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > :first-child {
    margin-bottom: var(--spacing-100);
  }
}
</style>
